module.exports = __webpack_public_path__ + "img/list-check-box-inactive.dac4212e.svg";